import { UPDATE_PARTS } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PARTS:
      return { ...state, ...action.payload.entities.parts };
    default:
      return state;
  }
};

export default reducer;
